import { TenantConfig } from '../../../../../core/interfaces/tenant-config.interface';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { getTenantConfig } from '../../../../../core/constants/tenant-config.constants';

export class TenantHelper {
  static getTenantByType(tenantType: TenantKey): TenantConfig {
    return getTenantConfig(tenantType);
  }
}
